<template>
  <nav class="menu">
    <div class="clearfix">
      <div
        class="right menu_item"
        :class="{active: index === hoverIndex}"
        v-for="(menu_item,index) in sortedMenu"
        :key="index"
      >
        <div class="menu_item_top ease">
          <router-link
            :to="{ path: menu_item.top.url.replace(homeUrl, '') }"
            replace
          >
          <span v-if="!menu_item.img">{{ menu_item.top.title }}</span>
          <img v-if="menu_item.img" :src="menu_item.img" alt="">
          </router-link>
        </div>
        <div class="drop_down" v-if="menu_item.inner">
          <arrow_down />
        </div>
        <div
          class="menu_drop "
          :class="[{
            'menu_drop_big' : (Object.values(menu_item.inner).length>5 ? true : false) ,
            'has_sale' : hasSale(menu_item.top.object_id),
          }, menu_item.classes]"
          v-if="menu_item.inner"
        >
          <div
            class="drop_img cover"
            v-bind:style="[getCategory(menu_item.top.object_id) && getCategory(menu_item.top.object_id).hasOwnProperty('header_image') ? { backgroundImage: 'url(' + getCategory(menu_item.top.object_id).header_image + ')' } : {}]"
          ></div>
          <div class="drop_title">
             <span v-if="!menu_item.img">{{ menu_item.top.title }}</span>
          <img v-if="menu_item.img" :src="menu_item.img" alt=""></div>
          <div
            class="clearfix"
            :class="{'column-2' : (Object.values(menu_item.inner).length>5 ? true : false)}"
          >
            <div
              class="drop_col"
              :class="{'' : (Object.values(menu_item.inner).length>5 ? true : false)}"
              v-for="(inner_menu_item, index) in menu_item.inner"
              :key="index"
            >
              <div class="drop_link" v-if="getCategory(inner_menu_item.top.object_id)">
                <router-link
                  :to="{ path: inner_menu_item.top.url.replace(homeUrl, '') }"
                  replace
                >{{ inner_menu_item.top.title }}</router-link>
              </div>
            </div>
          </div>
          <div class="drop_sale" v-if="hasSale(menu_item.top.object_id)">
            <a
              href="#"
              @click.prevent="salesPop(getCategory(menu_item.top.object_id).sale.id)"
              v-html="getCategory(menu_item.top.object_id).sale.text"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import arrow_down from "../../assets/img/arrow_down.svg";
import { mapActions, mapGetters, mapState } from "vuex";
import store from "../../store";

export default {
  props: ["menu", "assets"],
  data() {
    return {
      homeUrl: wpData.home_url,
      split: false,
      active_menu: "",
      hoverIndex: false
    };
  },
  watch: {
    $route(to, from) {
      this.hoverIndex = false;
    }
  },
  computed: {
    ...mapGetters({ getProduct: "getProductById" }),
    sortedMenu() {
      return this.menu;
      let sort = Object.values(this.menu);
      sort.sort((a, b) => a.top.menu_order - b.top.menu_order);
      for (let index = 0; index < sort.length; index++) {
        if (sort[index].inner) {
          sort[index].inner = Object.values(sort[index].inner);
          sort[index].inner.sort((a, b) => a.top.menu_order - b.top.menu_order);
        }
      }
      return sort;
    }
  },
  methods: {
    itemHover(index) {
      this.hoverIndex = index;
    },
    sortMenu() {
      return this.menu;
      let sort = Object.values(this.menu);
      sort.sort((a, b) => a.top.menu_order - b.top.menu_order);
      for (let index = 0; index < sort.length; index++) {
        if (sort[index].inner) {
          let inner = Object.values(sort[index].inner);
          inner = inner.sort((a, b) => a.top.menu_order - b.top.menu_order);
          //sort[index].inner = [];
          sort[index].inner = inner;
        }
      }
      return sort;
    },
    splitMenu(menu) {
      if (!menu) {
        return [];
      }
      let arrMenu = Object.values(menu);
      if (arrMenu.length > 5) {
        this.split = true;
        return arrMenu;
      }
      this.split = false;
      return arrMenu;
    },
    getCategory(id) {
      let category = this.$store.state.categories.find(cat => cat.id == id);
      return category;
    },
    hasSale(id) {
      let category = this.getCategory(id);
      if (category && typeof category.sale != "undefined" && category.sale) {
        return true;
      }
      return false;
    },
    saleDetails(id) {
      let sale_details = this.$store.state.sales.find(s => {
        if (s.code == id) {
          return s;
        }
      });
      return sale_details;
    },
    products(sale_id) {
      return new Promise((resolve, reject) => {
        let sale_products = Object.values(this.saleDetails(sale_id).products);
        this.$ajax({
          method: "POST",
          url: homeUrl + "ajax.php",
          params: {
            getProducts: "",
            ids: JSON.stringify(sale_products)
          }
        }).then(res => {
          resolve(res.data);
        });
      });
    },
    ...mapActions(["openPopupProduct"]),
    openProductPop(p) {
      this.openPopupProduct([p]).then(() => {
        this.$modal.show("prod-modal");
      });
    },
    salesPop(id) {
      this.products(id).then(res => {
        let products = res;
        if (products.length > 1) {
          this.$modal.show("sales-pop", {
            products: products
          });
        } else {
          this.openProductPop(products[0]);
        }
      });
    }
  },
  components: {
    arrow_down
  }
};
</script>

<style>
.menu_drop.submenu-left {
  right: auto;
  left: -60px;
}
</style>
